/**
 * Returns the default sub-tab for a given CSI item based on its itemCode.
 * Centralized logic to avoid repetition across ProjectDetail.js.
 * 
 * @param {Object} csiItem - The CSI item object with an itemCode property
 * @returns {string} The default sub-tab identifier
 */
export const getDefaultSubTab = (csiItem) => {
  if (!csiItem) return 'types';
  switch (csiItem.itemCode) {
    case '08 40 01': return 'sf-types';
    case '08 40 02': return 'cw-types';
    case '08 10 00': return 'door-types';
    case '08 00 01': return 'mirror-types';
    case '08 00 02': return 'shower-types';
    case '07 20 00': return 'thermal-products';
    case '27 01 00': return 'comm-general';
    default: return 'types';
  }
};
